import { z } from "zod";
import { isoDateTimeSchema } from "./time";

export const devicePlatformSchema = z.enum(["windows", "android", "browser"]);
export type DevicePlatform = z.infer<typeof devicePlatformSchema>;

export const deviceEncryptionAlgorithmSchema = z.literal("x25519-xchacha20poly1305-v1");
export type DeviceEncryptionAlgorithm = z.infer<typeof deviceEncryptionAlgorithmSchema>;

export const deviceEncryptionKeySchema = z.object({
  deviceId: z.string().uuid(),
  keyVersion: z.number().int().positive(),
  algorithm: deviceEncryptionAlgorithmSchema,
  publicKey: z.string().min(40).max(128)
});
export type DeviceEncryptionKey = z.infer<typeof deviceEncryptionKeySchema>;

export const deviceRegistrationSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  platform: devicePlatformSchema,
  label: z.string().trim().min(1).max(80),
  createdAt: isoDateTimeSchema,
  lastSeenAt: isoDateTimeSchema,
  revokedAt: isoDateTimeSchema.nullable()
});
export type DeviceRegistration = z.infer<typeof deviceRegistrationSchema>;

export const registerDeviceInputSchema = deviceRegistrationSchema.pick({
  id: true,
  userId: true,
  platform: true,
  label: true
});
export type RegisterDeviceInput = z.infer<typeof registerDeviceInputSchema>;
